'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var moment = require('moment');
moment().format();
moment.locale('de');

var DateTimeHelper = function () {
  function DateTimeHelper() {
    _classCallCheck(this, DateTimeHelper);
  }

  _createClass(DateTimeHelper, null, [{
    key: 'FormatToShortDateString',

    /**
       * formats a date object to a formated date string
       * @param date object
       * @constructor
       */
    value: function FormatToShortDateString(date, showDay) {
      if (date !== null && date !== undefined) {
        var languageFormat = "de";
        if (localStorage.getItem("vas_language")) {
          languageFormat = localStorage.getItem("vas_language");
        }
        var xDate = '';
        if (showDay === false) {
          switch (languageFormat) {
            case 'de':
              {
                xDate = date.format("MM.YYYY");
                break;
              }
            case 'en':
              {
                xDate = date.format("MM/YYYY");
                break;
              }
            default:
              break;
          }
        } else {
          switch (languageFormat) {
            case 'de':
              {
                xDate = date.format("DD.MM.YYYY");
                break;
              }
            case 'en':
              {
                xDate = date.format("MM/DD/YYYY");
                break;
              }
            default:
              break;
          }
        }

        return xDate;
        //return Intl.DateTimeFormat(languageFormat).format(date);
      } else {
        return '';
      }
    }
  }, {
    key: 'GetCalendarWeekForGivenDate',
    value: function GetCalendarWeekForGivenDate(date) {
      if (date !== undefined && date !== null) {
        return date.isoWeek();
      } else {
        return '';
      }
      /*if (!(date instanceof Date)) {date = new Date();}
            // ISO week date weeks start on Monday, so correct the day number
          let nDay = (date.getDay() + 6) % 7;
            // ISO 8601 states that week 1 is the week with the first Thursday of that year
          // Set the target date to the Thursday in the target week
          date.setDate(date.getDate() - nDay + 3);
            // Store the millisecond value of the target date
          let n1stThursday = date.valueOf();
            // Set the target to the first Thursday of the year
          // First, set the target to January 1st
          date.setMonth(0, 1);
            // Not a Thursday? Correct the date to the next Thursday
          if (date.getDay() !== 4) {
              date.setMonth(0, 1 + ((4 - date.getDay()) + 7) % 7);
          }
            // The week number is the number of weeks between the first Thursday of the year
          // and the Thursday in the target week (604800000 = 7 * 24 * 3600 * 1000)
          return 1 + Math.ceil((n1stThursday - date) / 604800000);*/
    }
  }, {
    key: 'GetFirstDayOfCurrentMonth',
    value: function GetFirstDayOfCurrentMonth() {
      var today = moment();
      return moment([today.year(), today.month(), 1]);
    }
  }, {
    key: 'GetLastDayOfMonth',
    value: function GetLastDayOfMonth(month, year) {

      var isLeap = false;

      if (DateTimeHelper.IsLeapYear(moment([year, month, 1]))) {
        isLeap = true;
      }

      switch (month) {
        case 0:
          return 31;
        case 1:
          {
            if (isLeap) {
              return 29;
            }
            return 28;
          }
        case 2:
          return 31;
        case 3:
          return 30;
        case 4:
          return 31;
        case 5:
          return 30;
        case 6:
          return 31;
        case 7:
          return 31;
        case 8:
          return 30;
        case 9:
          return 31;
        case 10:
          return 30;
        case 11:
          return 31;
        default:
          return 31;
      }
    }
  }, {
    key: 'GetMonthName',
    value: function GetMonthName(day) {
      switch (day) {}
    }
  }, {
    key: 'IsLeapYear',
    value: function IsLeapYear(date) {
      return date.isLeapYear();
    }
  }, {
    key: 'StringToDate',
    value: function StringToDate(date, isResponse, lang, showDay) {
      var newDate = moment();
      if (date) {
        if (isResponse === true) {
          newDate = moment(date, ["YYYY-MM-DD", moment.ISO_8601]);
        } else {
          switch (lang) {
            case 'de':
              date = date.split('.').join('/');
              if (showDay === false) {
                newDate = moment(date, "MM-YYYY");
              } else {
                newDate = moment(date, "DD-MM-YYYY");
              }
              break;
            case 'en':

              if (showDay === false) {
                newDate = moment(date, "MM-YYYY");
              } else {
                newDate = moment(date, "MM-DD-YYYY");
              }
              break;
            default:
              break;
          }
        }
      }
      return newDate;
    }
  }, {
    key: 'getAllIndexes',
    value: function getAllIndexes(arr, val) {
      var indexes = [],
          i = -1;
      while ((i = arr.indexOf(val, i + 1)) !== -1) {

        indexes.push(i);
      }
      return indexes;
    }
  }, {
    key: 'IsOfAge',
    value: function IsOfAge(date) {
      //Überprüft ob eine Person volljährig ist --> Übergabewert: Geburtsdatum
      var today = moment();
      var newDate = DateTimeHelper.StringToDate(date, false, localStorage.getItem('vas_language'));
      var jahre = today.year() - newDate.year();
      if (today.month() - newDate.month() < 0) {
        jahre--;
      } else {
        if (today.month() - newDate.month() === 0) {
          if (today.date() - newDate.date() < 0) {
            jahre--;
          }
        }
      }
      if (jahre < 18) {
        //alert("Die eingegebene Person ist nicht volljährig")
        return false;
      } else {
        //alert("Die eingegebene Person ist volljährig")
        return true;
      }
    }
  }]);

  return DateTimeHelper;
}();

exports.default = DateTimeHelper;